import instance from "@/lib/axios";
import type { Conversation } from "@/types/conversationTypes";

const baseApiUrl = import.meta.env.VITE_AGENTIC_BASE_API_URL;
const CONVERSATION_URL = `${baseApiUrl}conversation`;

export const conversationApi = {
  getConversationById: (conversationId: string) => instance.get<Conversation>(`${CONVERSATION_URL}/${conversationId}`),
};
